module.exports = __webpack_public_path__ + "static/media/alert.f1969ba1.svg";